import { BrowserRouter, Routes, Route } from 'react-router-dom'

// pages & components
import Home from './pages/Home';
// import HomeFormOnly from './pages/HomeFormOnly';
// import Navbar from './components/Navbar';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* <Navbar /> */}
        <Routes>
          <Route
            path="/"
            element={<Home />}
          />
          {/* <Route
            path="/form"
            element={<HomeFormOnly />}
          /> */}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
